import React from "react";
import { useLang } from "../../context/LangContext";
import { STRINGS, TEAM } from "../../data/content";

export default function Team() {
  const { t } = useLang();
  return (
    <section className="section" style={{ background: "var(--off-white)" }}>
      <div className="section-inner">
        <div className="fade-in">
          <div className="section-label">{t(STRINGS.coachesLabel)}</div>
        </div>
        <h2 className="section-title fade-in">{t(STRINGS.coachesTitle)}</h2>
        <p className="section-sub fade-in">{t(STRINGS.coachesSub)}</p>
        <div className="team-grid">
          {TEAM.map((m) => (
            <div className="team-card fade-in" key={m.id}>
              <img src={m.img} alt={m.name} className="team-photo" />
              <div className="team-info">
                <div className="team-name">{m.name}</div>
                <div className="team-role">{t(m.role)}</div>
                <div className="team-bio">{t(m.bio)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
